import { Ability } from '@casl/ability';
/**
 * doc https://github.com/stalniy/casl/tree/master/packages/casl-vue
 */
import { abilitiesPlugin } from '@casl/vue';
import Vue from 'vue';

const ability = new Ability();
Vue.use(abilitiesPlugin, ability);
